var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_14076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10.1535H7V11.8889H9V10.1535ZM13 10.1535H11V11.8889H13V10.1535ZM17 10.1535H15V11.8889H17V10.1535ZM19 4.07938H18V2.34393H16V4.07938H8V2.34393H6V4.07938H5C3.89 4.07938 3.01 4.86034 3.01 5.81483L3 17.963C3 18.9175 3.89 19.6984 5 19.6984H19C20.1 19.6984 21 18.9175 21 17.963V5.81483C21 4.86034 20.1 4.07938 19 4.07938ZM19 17.963H5V8.41801H19V17.963Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_14076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20.8254,
    fill: "white",
    transform: "translate(0 0.608459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0b0838cc.svg";
export { ForwardRef as ReactComponent };